import * as Constants from 'app-constants'
import type { PurposityEnv } from 'purposity-env'

declare global {
   
  var PURPOSITY_ENV: PurposityEnv
}

globalThis.PURPOSITY_ENV = Constants.PURPOSITY_ENV
